import * as React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { connect } from 'react-redux';
import { showRequestCancelLifePolicy } from "../../actions/modalActions";
import { navigateTo } from '../../actions/navigationActions';
import { hideMobileProfile } from '../../actions/profileActions';
import { DASHBOARD, LIFE_INSURANCE, LIFE_UPDATE_BENEFICIARIES } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import './LifeInsuranceCover.css';

class LifeInsuranceCover extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
        }
        
        this.handleRedirect = this.handleRedirect.bind(this);
        this.changeEdit = this.changeEdit.bind(this);
        this.handleUpdateBeneficiaries = this.handleUpdateBeneficiaries.bind(this);
        this.dismissMonthlyMileageReminder = this.dismissMonthlyMileageReminder.bind(this);
        this.handleRequestCancellation = this.handleRequestCancellation.bind(this);
        this.handleShareWithBeneficiaries = this.handleShareWithBeneficiaries.bind(this);
        this.handleDigicardDownload = this.handleDigicardDownload.bind(this);
    }
    
    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }
    
    handleUpdateBeneficiaries(e) {
        this.handleRedirect(LIFE_UPDATE_BENEFICIARIES);
    }

    componentDidMount() {

        const activeBenefitId = this.props.lifePolicy.policy.activeBenefitId;
        const mainBenefit = this.props.lifePolicy.policy.benefits.filter((ben) => ben.id === activeBenefitId)[0];

        this.setState({
            selectedBenefit: mainBenefit,
        });
        this.props.dispatchHideProfile();
    }

    dismissMonthlyMileageReminder() {
        this.setState({ updateReminderDismissed: true });
    }
    
    handleRequestCancellation() {
        this.props.showRequestCancelLifePolicy();
    }

    changeEdit() {
        this.setState({ isInEdit: !this.state.isInEdit });
    }
    
    handleDigicardDownload() {
        
    }
    
    handleShareWithBeneficiaries() {
        
    }

    public render() {

        const activeBenefitId = this.props.lifePolicy.policy.activeBenefitId;
        const mainBenefit = this.props.lifePolicy.policy.benefits.filter((ben) => ben.id === activeBenefitId)[0];

        let cover = mainBenefit && mainBenefit.id && <>
                <div>
                    <div id="life-insurance-cover" className="row justify-content-between border-bottom pb-3">
                        <div className="col-12 col-lg-6 row">
                            <div className="col-lg-8 col-md-8 mb-2">
                                <h2 className="carName mb-0">{ mainBenefit.name }</h2>
                            </div>
                            <div className="col-lg-8 mb-2">
                                <p className="mb-0">Cover amount</p>
                            <p className="life-insurance-cover__amount currency">{ mainBenefit.benefitAmount }</p>
                            </div>
                            <div className="col-lg-8 mb-2">
                                <p className="mb-0">Monthly premium</p>
                                <h3 className="life-insurance-cover__amount currency mb-2">R { mainBenefit.premiumAmount }</h3>
                            </div>
                        </div>
                        <div className="life-insurance-cover__actions col-12 col-lg-6">
                            <div className="life-insurance-cover__action text-right">
                                <button className="btn btn-solid-red" onClick={this.changeEdit} id="EditPolicy">Update { mainBenefit.name.toLowerCase() }</button>
                            </div>
                            <div className="life-insurance-cover__action text-right">
                                <button onClick={this.handleUpdateBeneficiaries} className="btn btn-outline-red">Update beneficiaries</button>
                            </div>
                        </div>
                    </div>
                    { mainBenefit.addons?.length > 0 && 
                    <>
                        <div className="row mt-2">
                            <div className="col-12">
                                <h5 className="text-Left font-weight-bold mb-0">My { mainBenefit.name } benefits</h5>
                            </div>
                        </div>
                        <hr className="life-insurance-break"/>
                    </>
                    }
                    
                    <div className="row mt-2">
                        <h3 className="text-Left life-insurance__policyholder-text col-sm-6 mb-0">Policyholder</h3>
                        <h3 className="text-right life-insurance__term-text col-sm-6 mb-0">Cover term</h3>
                    </div>
                    <div className="row mt-2">
                        <p className="col-sm-6 life-insurance__policyholder-value text-left">{ this.props.lifePolicy.policy.contact.name }</p>
                        <p className="col-sm-6 life-insurance__term-value text-right">{ mainBenefit.term }</p>
                    </div>
                    <hr className="life-insurance-break"/>
                    <div className="row justify-content-between mt-2">
                        <h5 className="font-weight-bold col-sm-6 text-left">Payout type</h5>
                        <h5 className="font-weight-bold col-sm-6 life-details text-right">{ mainBenefit.payoutTerm }</h5>
                    </div>
                    <hr className="life-insurance-break"/>
                    <div className="row justify-content-between mt-2 mb-3">
                        <h5 className="col-12 font-weight-bold text-left">Your digicard</h5>
                        <h5 className="col-12 life-insurance__digicard-text text-left">
                            Your digicard is your quick way to share the information below with a beneficiary, this will allow  your beneficiary to claim in the event of death. Please note only the information shown will be shared, no payment amounts will be disclosed. 
                        </h5>
                    </div>
                    <div className="col-12">
                        <div className="row life-insurance__digicard justify-content-between">
                            <div className="col-12 life-insurance__digicard-upper">
                                <div className="row life-insurance__digicard-block p-2 justify-content-between align-items-center">
                                    <img className="ml-4" src="./Images/LifeInsurance/kp-logo.png" />
                                    <h4 className="life-insurance__digicard-title pr-3">Livin' policy DigiCard</h4>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="row justify-content-between p-3 pt-5">
                                    <div className="row col-12 col-xl-8">
                                        <div className="col-6">
                                            <p><b>Policyholder</b> { this.props.lifePolicy.policy.contact.name }</p>
                                        </div>
                                        <div className="col-6">
                                            <p><b>Policy no.</b> { this.props.lifePolicy.policy.name }</p>
                                        </div>
                                        <div className="col-6">
                                            <p><b>Start date</b> { this.props.lifePolicy.policy.startDate }</p>
                                        </div>
                                        <div className="col-6">
                                            <p><b>Date of birth</b> { this.props.lifePolicy.policy.contact.birthdate }</p>
                                        </div>
                                    </div>
                                    <div className="row life-insurance__digicard-actions col-12 col-xl-4">
                                        <div className="col-12 col-lg-6 col-xl-12">
                                            <button className="float-right life-insurance-cover__share-beneficiaries-button btn btn-solid-red mb-3" onClick={this.handleShareWithBeneficiaries}>Share with beneficiaries</button>
                                        </div>
                                        <div className="col-12 col-lg-6 col-xl-12">
                                            <button className="float-right life-insurance-cover__download-digicard-button btn btn-outline-red mb-3" onClick={this.handleDigicardDownload}>Download</button>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="mt-4 mb-2">
                    <Accordion defaultActiveKey="0">
                        <Card className="mb-lg-3 life-insurance-cover__update-beneficiaries-card">
                            <Accordion.Toggle className="life-insurance-cover__update-beneficiaries-accordion-toggle" as={Card.Header} eventKey="0">
                                <p className="CardTitle">Beneficiaries</p>
                                <i className="fas fa-plus float-right "></i>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0">
                                <Card.Body className="p-3">
                                    { mainBenefit?.beneficiaries?.map((beneficiary) => 
                                    <>
                                        <div className="form-group row">
                                            <div className="col-sm-6 col-form-label">
                                                <p className="mb-0 life-insurance-cover__update-beneficiary-name">{ beneficiary.name }</p>
                                            </div>
                                            <div className="col-sm-6">
                                                <p className="form-control-plaintext life-insurance-cover__update-beneficiary-percentage text-right">{ beneficiary.percentage }%</p>
                                            </div>
                                        </div> 
                                        <hr />
                                    </>
                                    )}
                                    <div className="row justify-content-end">
                                        <div className="col-sm-6">
                                            <button className="float-right life-insurance-cover__update-beneficiaries-button btn btn-outline-red mb-3" onClick={this.handleUpdateBeneficiaries} id="EditPolicy">Update beneficiaries</button>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </div>
                <div className="row life-insurance__request-cancellation justify-content-end">
                    <div className="col-auto">
                        <button className="float-right btn mb-3" onClick={this.handleRequestCancellation} id="EditPolicy">Request cancellation</button>
                    </div>
                </div>
            </>
        
        const isMobile = window.innerWidth <= 975;
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: LIFE_INSURANCE, description: "Life insurance" }]

        return (
            <>
                {isMobile &&
                    <KPBreadCrumb navList={BreadcrumbDetails} activePage="Life cover" />
                }
                <div className="box col-12 pt-3 pb-3 mb-3">
                    {cover}
                </div>
            </>
        );
    }

}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        lifePolicy: state.lifePolicy,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        showRequestCancelLifePolicy: () => dispatch(showRequestCancelLifePolicy()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LifeInsuranceCover);